module.exports = "<md-toolbar color=\"primary\">\n  <h4 class=\"navigation-header\">TrysilBike</h4>\n  <ng-container *ngIf=\"authenticated\">\n    <a md-button [routerLink]=\"['/home']\">Pickups</a>\n    <a md-button [routerLink]=\"['/settings']\">Settings</a>\n    <span class=\"toolbar-spacer\"></span>\n    <button md-button (click)=\"signOut()\">Sign out</button>\n  </ng-container>\n</md-toolbar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 220
// module chunks = 1